module.exports = __webpack_public_path__ + "static/media/kronn-main.55a6d041.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/HomePageResources/kronn-main.svg
// module id = 147
// module chunks = 0